export const calculateRequiredSpots = (
  userCount: number,
  guestsPerUser: number
): number => userCount * (1 + guestsPerUser);
